import { GzRmCvesSeverityWidgetWebComponent } from './component/GzRmCvesSeverityWidgetWebComponent';

export { GzRmCvesSeverityWidgetWebComponent };
